(() => {
  if (!customElements.get('stock-alternatives')) customElements.define('stock-alternatives', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      if (!this.dataset.url) return;
      const request = this.controller = new AbortController();
      const timeout = this.timeout = setTimeout(() => request.abort(), 8000);
      fetch(this.dataset.url, { signal: request.signal }).then(response => {
        if (!response.ok) throw new Error('Unavailable');
        return response.text();
      }).then(html => {
        if (!this.isConnected || request.signal.aborted) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = [...doc.querySelectorAll('stock-alternatives')].find(item => item.dataset.blockId === this.dataset.blockId)?.querySelector('[data-stock-alternatives-content]');
        if (next?.querySelector('li')) this.querySelector('[data-stock-alternatives-content]').replaceWith(next);
      }).catch(() => {}).finally(() => clearTimeout(timeout));
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timeout); }
  });
  if (customElements.get('stock-alert-form')) return;
  customElements.define('stock-alert-form', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.form = this.querySelector('form');
        this.fieldset = this.querySelector('fieldset');
        this.status = this.querySelector('[role="status"]');
        this.email = this.querySelector('[name="email"]');
        this.marketing = this.querySelector('[name="marketing"]');
        if (!this.form) return;
        if (this.marketing) this.marketing.checked = false;
        this.configured = /^[a-zA-Z0-9]{6}$/.test(this.dataset.siteId) && /^[a-zA-Z0-9]{6}$/.test(this.dataset.listId);
        this.fieldset.disabled = !this.configured;
        if (!this.configured) this.status.textContent = this.dataset.error;
        this.form.addEventListener('submit', event => this.submit(event), { signal: this.controller.signal });
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.request?.abort(); clearTimeout(this.timeout); }
    async post(endpoint, data) {
      this.request = new AbortController();
      this.timeout = setTimeout(() => this.request.abort(), 12000);
      try {
        const response = await fetch(`https://a.klaviyo.com/client/${endpoint}/?company_id=${encodeURIComponent(this.dataset.siteId)}`, {
          method: 'POST', credentials: 'omit', signal: this.request.signal,
          headers: { accept: 'application/vnd.api+json', 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify({ data })
        });
        if (response.status !== 202) throw new Error('Request not accepted');
      } finally { clearTimeout(this.timeout); }
    }
    async submit(event) {
      event.preventDefault();
      if (!this.configured || this.pending || !this.form.reportValidity() || this.querySelector('[data-honeypot]').value) return;
      if (this.hasAttribute('data-design-mode')) { this.status.textContent = 'Editor preview only. No request has been sent.'; return; }
      const email = this.email.value.trim();
      const key = `${email.toLowerCase()}:${this.dataset.variantId}`;
      const marketing = this.marketing?.checked === true;
      const profile = { data: { type: 'profile', attributes: { email } } };
      this.pending = true;
      this.fieldset.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      try {
        if (this.accepted !== key) {
          if (this.dataset.state === 'managed' && this.dataset.catalogReady !== 'true') {
            await this.post('events', { type: 'event', attributes: {
              unique_id: this.eventKey === key ? this.eventId : (this.eventKey = key, this.eventId = crypto.randomUUID()),
              metric: { data: { type: 'metric', attributes: { name: 'TFFC Stock Alert Requested' } } }, profile,
              properties: { ProductID: this.dataset.productId, VariantID: this.dataset.variantId, ProductName: this.dataset.productTitle, ProductURL: this.dataset.productUrl, Source: 'Out-of-stock product page', Availability: 'managed', Channel: 'EMAIL' }
            } });
          } else {
            const variant = this.dataset.state === 'managed' && this.dataset.catalogReady === 'true' ? `$custom:::$default:::${this.dataset.catalogPrefix}${this.dataset.variantId}` : `$shopify:::$default:::${this.dataset.variantId}`;
            await this.post('back-in-stock-subscriptions', { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile }, relationships: { variant: { data: { type: 'catalog-variant', id: variant } } } });
          }
          this.accepted = key;
        }
        if (!this.isConnected) return;
        if (marketing) {
          try {
            await this.post('subscriptions', { type: 'subscription', attributes: { custom_source: 'Stock alert — optional marketing consent', profile: { data: { type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: this.dataset.listId } } } });
          } catch {
            if (this.isConnected) this.status.textContent = this.dataset.marketingError;
            return;
          }
        }
        if (this.isConnected) { this.status.textContent = this.dataset.success; this.form.reset(); this.complete = true; }
      } catch {
        if (this.isConnected) this.status.textContent = this.dataset.error;
      } finally {
        this.pending = false;
        if (this.isConnected) { this.fieldset.disabled = this.complete || !this.configured; this.form.removeAttribute('aria-busy'); }
      }
    }
  });
})();
